module.exports = __webpack_public_path__ + "img/tuin_achtertuin.bde738d7.png";